import axios from 'axios';
import BaseUrl from './BaseUrl';


let controllers = []; // 🔴 all active controllers

export const createController = () => {
    const controller = new AbortController();
    controllers.push(controller);
    return controller;
};

export const cancelAllRequests = () => {
    controllers.forEach(c => c.abort());
    controllers = [];
};

export default axios.create({
        baseURL: `${BaseUrl()}/api`,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization':'Bearer '+localStorage.getItem("token")??""
    }
});